export default {
    mounted() {
        this.analyticsScripts();
        this.adsScripts();
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    },
    methods: {
        analyticsScripts() {
            let analytics1 = document.createElement('script');
            analytics1.setAttribute('async', '');
            analytics1.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-FH9F1YCE4C%22%3E');
            document.head.appendChild(analytics1);
            
            let analytics2 = document.createElement('script');
            analytics2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'G-FH9F1YCE4C');
            `;
            document.head.appendChild(analytics2);
        },
        adsScripts() {
            let ads1 = document.createElement('script');
            ads1.setAttribute('data-ad-client', 'ca-pub-2512331316053279');
            ads1.setAttribute('async', '');
            ads1.setAttribute('src', 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js');
            document.head.appendChild(ads1);
        }
    }
}